import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {LanguageService} from '../../../services/language.service';
import {interval} from 'rxjs';
import {NavigationComponent} from '../../navigation/navigation.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger('flyInOut', [
      state('in', style({ opacity: '1' })),
      transition('void => *', [
        style({ opacity: '0' }),
        animate(1000)
      ]),
      transition('* => void', [
        animate(1000, style({opacity: '1'}))
      ])
    ])
  ]
})
export class HeaderComponent implements OnInit, OnDestroy {

  index = 0;
  numImages = 2;
  imagesLoaded = 0;
  loading = true;
  imagesUrl = [
    'https://quickhub.co.il/wp-content/uploads/2023/10/רקע-1.jpeg',
    'https://quickhub.co.il/wp-content/uploads/2023/10/רקע-2.jpg'
  ];

  @ViewChild('header', {static: false}) public header: ElementRef;
  @ViewChild('navigationBar', {static: false}) public navigationBar: NavigationComponent;

  public title = 'QuickHub';
  public tagline = 'Productive Workplace';

  public route: string;

  constructor(public languageService: LanguageService) {}

  public ngOnInit(): void {
    window.addEventListener('scroll', this.scroll, true);
    this.imagesUrl.forEach((x, index) => {
      const image = new Image();
      image.onload = (() => {
        this.imagesLoaded++;
        this.loading = (this.imagesLoaded !== this.numImages);
      });
      image.src = x;
    });
    interval(5000).subscribe(() => {
      if (!this.loading) {
        this.index = (this.index + 1) % this.numImages;
      }
    });
  }

  public ngOnDestroy(): void {
    window.removeEventListener('scroll', this.scroll, true);
  }

  public scroll = (): void => {
    if (this.header) {
      this.navigationBar.isPageScrolled = this.header.nativeElement.getBoundingClientRect().top !== 0;
    }
  }

}
